/* eslint-disable */
require('./avator')
require('./common')
require('./console')
require('./email-auth-big')
require('./enginner-auth-big')
require('./enterprise-auth-big')
require('./exit')
require('./home')
require('./labor_gray')
require('./labor-auth')
require('./labor')
require('./logo-text')
require('./logo-white')
require('./material-auth-big')
require('./message')
require('./mobile-auth-big')
require('./org')
require('./password-big')
require('./plus-nocircle')
require('./progress')
require('./realname-auth-big')
require('./success-1')
require('./success')
require('./table-empty')
require('./upload-new')
require('./upload')
require('./user')
require('./vue')
require('./warning-1')
require('./warning-2')
require('./warning')



// WEBPACK FOOTER //
// ./src/views/icons/index.js